import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography, Paper, CircularProgress } from "@mui/material";
import { useIntl } from "react-intl";
import { useAuth } from "../../providers/AuthProvider";
import { useNotification } from "../../providers/NotificationProvider";
import { fetchCompany } from "../../api/memberApi";

export default function CompanyValuesPage() {
  const intl = useIntl();
  const { companyId } = useAuth();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const data = await fetchCompany(companyId);
      setCompany(data);
    } catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, [loadData]);

  if (loading) return <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>{t("tree.companyValues")}</Typography>
      {company ? (
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>{company.companyName}</Typography>
          {company.purpose ? (
            <Typography variant="body1" sx={{ whiteSpace: "pre-wrap" }}>{company.purpose}</Typography>
          ) : (
            <Typography color="text.secondary">{t("common.noData")}</Typography>
          )}
        </Paper>
      ) : (
        <Typography color="text.secondary">{t("common.noData")}</Typography>
      )}
    </Box>
  );
}
